export const customerDocuments = {
  documentHeader: {
    en: 'Documents and letters',
    nb: 'Dokumenter og brev',
    nn: 'Dokumenter og brev',
  },
  filterDocumentTypeHeader: {
    en: 'Document Type',
    nb: 'Dokumenttype',
    nn: 'Dokumenttype',
  },
  documents: {
    en: 'Annual statements',
    nb: 'Årsoppgaver',
    nn: 'Årsoppgaver',
  },
  appealDecision: {
    en: 'Appeal a decision',
    nb: 'Klage på vedtak',
    nn: 'Klage på vedtak',
  },
  appealIntro: {
    en: 'You can',
    nb: 'Du kan',
    nn: 'Du kan',
  },
  appealOutro: {
    en: 'within 3 weeks after receiving it.',
    nb: 'innen 3 uker etter at vedtaket er mottatt.',
    nn: 'innan 3 veker etter at vedtaket er motteke',
  },
  noRoles: {
    en: 'You do not have the clearance to access the documents for this company.',
    nb: 'Du har ikke de nødvendige rettighetene til å se denne bedriftens dokumenter.',
    nn: 'Du har ikkje dei naudsynte rettighetane til å sjå denne bedriftens dokumenter.',
  },
  invoiceInformation: {
    en: 'Invoices can be found on the relevant account via the account overview.',
    nb: 'Fakturaer finner du på aktuell konto via kontooversikten.',
    nn: 'Fakturaer finn du på aktuell konto via kontooversikten.',
  },
  ApplicationDocument: {
    en: 'Response Letter',
    nb: 'Svarbrev',
    nn: 'Svarbrev',
  },
  BankingAnnualStatement: {
    en: 'Annual Report',
    nb: 'Årsrapport',
    nn: 'Årsrapport',
  },
  BankingInterestRateChangeDocument: {
    en: 'Interest Rate Change',
    nb: 'Renteendring',
    nn: 'Renteendring',
  },
  BankingDeferralPaymentDocument: {
    en: 'Payment Deferral',
    nb: 'Betalingsutsettelse',
    nn: 'Betalingsutsettelse',
  },
} as const;
